import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { UserService, BaseDataService, BaseCommonComponent, ModalService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
//import { formGroupNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { FormGroup, FormControl, Validators } from '@angular/forms';
//import { formControlBinding } from '@angular/forms/src/directives/ng_model';
import { KarticaMpArtikla } from './kartica-mp-artikla';
import { ModelDataService } from 'yt-ng-framework';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { Subject } from 'rxjs';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-kartica-mp-artikla',
  templateUrl: './kartica-mp-artikla.component.html'
})
export class KarticaMpArtiklaComponent
  extends BaseCommonComponent
  implements OnInit {
  Config = {}
  mainItems = []

   baseFormGroup:FormGroup=new FormGroup({
  //   DatumOd:new FormControl()
  //   , DatumDo:new FormControl()
  //   , RobaID:new FormControl()
  //   , KomitentID:new FormControl()
   })

  // get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;
  podaciSuUcitani: boolean=false;
  // OmogucenaPromenaUslova;
  OmogucenaPromenaUslova = new Subject<boolean>();

  constructor(

    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    public modelDataService: ModelDataService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  ) {

    super(activatedRoute
      , userService
      , baseDataService
      , translateService
      , modalService
      , toastrService
    );
    // this.OmogucenaPromenaUslova = new Subject();
    
  }

  ngOnInit() {
    // this.routeName="kartica-mp-artikla";
    super.ngOnInit();
    // this.addValidatorToFc("DatumOd", Validators.required, 'required', 'KARTICAMPARTIKLA.DATUMOD.VALIDATION.REQUIRED');
    // this.addValidatorToFc("DatumDo", Validators.required, 'required', 'KARTICAMPARTIKLA.DATUMDO.VALIDATION.REQUIRED');
    // this.addValidatorToFc("RobaID", Validators.required, 'required', 'KARTICAMPARTIKLA.ROBAID.VALIDATION.REQUIRED');
    let dateNow = new Date();
    this.baseFormGroup = new FormGroup({
      DatumOd: new FormControl(new NgbDate(dateNow.getFullYear(), 1, 1), [Validators.required]),
      DatumDo: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
      RobaID: new FormControl(null, [Validators.required]),
      KomitentID: new FormControl()
      //VrstaIzvestajaSinteticki: new FormControl("true", [Validators.required])
    })
  }



  OnModelDataLoaded() {
    super.OnModelDataLoaded();
    this.Config = {
      EditIcon: {
        Visible: this.modelData.MainList.EnableEdit
      },
      DeleteIcon: {
        Visible: this.modelData.MainList.EnableDelete
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100c',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: this.modelData.MainList.EnablePrint
      }
      , BreadCrumble: this.modelData.BreadcrumbLabel
    }
  }


  OnDataLoaded(){
    // super.OnDataLoaded();

    this.podaciSuUcitani=true;
    this.baseFormGroup.get("DatumOd").disable();
    this.baseFormGroup.get("DatumDo").disable();
    this.baseFormGroup.get("RobaID").disable();
    this.baseFormGroup.get("KomitentID").disable();
    super.OnDataLoaded();
  }

  LoadSumForm() {

    let _modelData = this.modelDataService.GetModelDataByPath("kartica-mp-artikla-ukupno");

    // let qpDatumOd = new QueryParameter("DatumOd", this.baseFormGroup.get("DatumOd").value);
    // let qpDatumDo = new QueryParameter("DatumDo", this.baseFormGroup.get("DatumDo").value);
    // let qpKomitentID = new QueryParameter("KomitentID", this.baseFormGroup.get("KomitentID").value);
    // let qpRobaID = new QueryParameter("RobaID", this.baseFormGroup.get("RobaID").value);

    let total;
    total = this.items.filter(x => x.PoslednjiUlaz == true);
    if (total.size==0)
      total = this.items.filter(x => x.SumarniSlog == true);

    let qpT01StanjeArtiklaZaPeriod
      = new QueryParameter("T01StanjeArtiklaZaPeriod", total.get(0)["T01StanjeArtiklaZaPeriod"]);
    let qpT02ProdajnaCenaArtiklaNaKrajuPeriod
      = new QueryParameter("T02ProdajnaCenaArtiklaNaKrajuPeriod", total.get(0)["T02ProdajnaCenaArtiklaNaKrajuPeriod"]);
    let qpT03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda
      = new QueryParameter("T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda", total.get(0)["T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda"]);
    let qpT04VrednostLageraArtiklaNaKrajuPerioda
      = new QueryParameter("T04VrednostLageraArtiklaNaKrajuPerioda", total.get(0)["T04VrednostLageraArtiklaNaKrajuPerioda"]);
    let qpT05VrednostLageraBezPdvArtiklaNaKrajuPerioda
      = new QueryParameter("T05VrednostLageraBezPdvArtiklaNaKrajuPerioda", total.get(0)["T05VrednostLageraBezPdvArtiklaNaKrajuPerioda"]);
    let qpT06VrednostUlazaArtiklaPoNabavnojCeni
      = new QueryParameter("T06VrednostUlazaArtiklaPoNabavnojCeni", total.get(0)["T06VrednostUlazaArtiklaPoNabavnojCeni"]);
    let qpT07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni
      = new QueryParameter("T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni", total.get(0)["T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni"]);
    let qpT08VrednostIzlazaArtiklaPoProdajnojCeni
      = new QueryParameter("T08VrednostIzlazaArtiklaPoProdajnojCeni", total.get(0)["T08VrednostIzlazaArtiklaPoProdajnojCeni"]);
    let qpT09UkupnoPdvIzlazRobe
      = new QueryParameter("T09UkupnoPdvIzlazRobe", total.get(0)["T09UkupnoPdvIzlazRobe"]);
    let qpT10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv
      = new QueryParameter("T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv", total.get(0)["T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv"]);
    let qpT11RealizacijaDoUlozenogNovca
      = new QueryParameter("T11RealizacijaDoUlozenogNovca", total.get(0)["T11RealizacijaDoUlozenogNovca"]);
    let qpT12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda
      = new QueryParameter("T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda", total.get(0)["T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda"]);

    // this.modalService.ShowModal(0, _modelData, null, false, [qpDatumOd, qpDatumDo, qpKomitentID, qpRobaID])
    this.modalService.ShowModal(0, _modelData, null, false, [
      qpT01StanjeArtiklaZaPeriod
      , qpT02ProdajnaCenaArtiklaNaKrajuPeriod
      , qpT03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda
      , qpT04VrednostLageraArtiklaNaKrajuPerioda
      , qpT05VrednostLageraBezPdvArtiklaNaKrajuPerioda
      , qpT06VrednostUlazaArtiklaPoNabavnojCeni
      , qpT07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni
      , qpT08VrednostIzlazaArtiklaPoProdajnojCeni
      , qpT09UkupnoPdvIzlazRobe
      , qpT10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv
      , qpT11RealizacijaDoUlozenogNovca
      , qpT12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda])
      .result
      .then((item) => {
        //OK
      }, (reason) => {
        //!OK
      }
    )
  }

  MenjajUslove() {
    this.baseFormGroup.get("DatumOd").enable()
    this.baseFormGroup.get("DatumDo").enable();
    this.baseFormGroup.get("RobaID").enable();
    this.baseFormGroup.get("KomitentID").enable();
    this.podaciSuUcitani=false;
    this.OmogucenaPromenaUslova.next(true);
    
  }

}
